<template>
  <ins
    class="adsbygoogle"
    :style="{ display: `inline-block`, width: `${wid}`, height: `${hgt}` }"
    data-ad-client="ca-pub-8370308321819212"
    data-ad-slot="7350126089"
  ></ins>
</template>

<script>
export default {
  props: {
    wid: { Type: String, default: "300px" },
    hgt: { Type: String, default: "250px" },
  },
};
</script>

<style scoped>
ins {
    background:none !important;
    color: black !important;
    text-decoration: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Ad/AdGoogle.vue